module.exports = __webpack_public_path__ + "img/sidebar.2f60bff8.png";